import { graphql } from '../gql';

export const projectNotification = graphql(/* GraphQL */ `
    mutation projectNotification($data: ProjectNotificationInput!) {
        projectNotification(data: $data) {
            id
            notification
            message
            metadata
        }
    }
`);

export const onProjectUpdate = graphql(`
    subscription onProjectUpdate($id: ID!) {
        onProjectUpdate(id: $id) {
            id
            notification
            message
            metadata
        }
    }
`);
